import { ReactElement, RefObject, useEffect, useMemo, useState } from 'react';

import mapboxgl from 'mapbox-gl';

import { bbox, bboxPolygon } from '@turf/turf';

import { useAppDispatch, useAppSelector } from 'state/hooks';
import {
  selectCurrentProjectInfo,
  selectMapCenter,
  selectMapZoom,
} from 'state/workflowSlice';

import { recenterMapToProjectBbox } from 'features/map/utils/mapCommon';
import { isGeometryOnMap } from 'features/map/utils/mapUtils';
import { FloatingDiv } from 'features/spinner/Spinner';

export function OutsideBboxPrompt({
  currentRefMap,
}: {
  currentRefMap: RefObject<mapboxgl.Map>;
}): ReactElement {
  const dispatch = useAppDispatch();
  const userProject = useAppSelector(selectCurrentProjectInfo);
  const currentMapCenter = useAppSelector(selectMapCenter);
  const mapZoom = useAppSelector(selectMapZoom);

  const [outsideBbox, setOutsideBbox] = useState(false);

  const project_bbox = useMemo(() => {
    if (userProject.project_boundary) {
      return bboxPolygon(bbox(userProject.project_boundary)).geometry;
    }
    return undefined;
  }, [userProject]);

  useEffect(() => {
    if (!userProject || !currentRefMap.current || !project_bbox) {
      setOutsideBbox(false);
    } else {
      setOutsideBbox(!isGeometryOnMap(project_bbox, currentRefMap.current));
    }
  }, [currentMapCenter, mapZoom, project_bbox]);

  return (
    outsideBbox && (
      <FloatingDiv
        onClick={() => {
          recenterMapToProjectBbox(dispatch, userProject);
        }}
      >
        Map is outside data area. Click to recenter.
      </FloatingDiv>
    )
  );
}
